import Adobe from "@/pixels/providers/adobe";
import * as STEP_CONSTANTS from "@/config/constants/step-constants";

describe("Adobe config", () => {
  it("configuracion exportada por defecto", () => {
    expect(Adobe).toBeDefined();
    expect(Adobe).not.toBeNull();
    expect(typeof Adobe).toBe("object");
  });

  describe("Eventos Propios de la Libreria", () => {
    beforeEach(() => {
      window.digitalData = {};
      jest.spyOn(Adobe, "enable");
      jest.spyOn(Adobe, "wait");
      jest.spyOn(Adobe, "init");
    });

    afterEach(() => {
      jest.clearAllMocks();
    });

    it("deberia llamar a Adobe.enable()", () => {
      Adobe.enable();
      expect(Adobe.enable).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.wait()", () => {
      Adobe.wait();
      expect(Adobe.wait).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.init()", () => {
      Adobe.init();
      expect(Adobe.init).toHaveBeenCalledTimes(1);
    });
  });

  describe("Eventos de Click", () => {
    const context = { mutation: { payload: "cliente" } };
    beforeEach(() => {
      window.digitalData = {};
      jest.spyOn(Adobe, "appStartedClick");
      jest.spyOn(Adobe, "ingresoBancaOnline");
      jest.spyOn(Adobe, "internalLink");
    });

    afterEach(() => {
      jest.clearAllMocks();
    });

    it("deberia llamar a Adobe.appStartedClick()", () => {
      Adobe.appStartedClick(context);
      expect(Adobe.appStartedClick).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.internalLink() por base", () => {
      Adobe.internalLink(context);
      expect(Adobe.internalLink).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.ingresoBancaOnline() por base", () => {
      Adobe.ingresoBancaOnline(context);
      expect(Adobe.ingresoBancaOnline).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.ingresoBancaOnline() por CA", () => {
      const context = { mutation: { payload: "noCliente" } };
      Adobe.ingresoBancaOnline(context);
      expect(Adobe.ingresoBancaOnline).toHaveBeenCalledTimes(1);
    });
  });

  describe("Eventos del Camino 1", () => {
    const context = {};
    beforeEach(() => {
      window.digitalData = {};
      jest.spyOn(Adobe, "ofertaCuenta");
      jest.spyOn(Adobe, "ofertaEmprendedores");
      jest.spyOn(Adobe, "datosPersonales");
      jest.spyOn(Adobe, "datosLaborales");
      jest.spyOn(Adobe, "informacionAdicional");
      jest.spyOn(Adobe, "identidad");
      jest.spyOn(Adobe, "loadingVeridas");
      jest.spyOn(Adobe, "biometriaOK");
      jest.spyOn(Adobe, "configuracion");
      jest.spyOn(Adobe, "contrato");
      jest.spyOn(Adobe, "graciasCajaAhorro");
      jest.spyOn(Adobe, "graciasEmprendedores");
    });

    afterEach(() => {
      jest.clearAllMocks();
    });

    it("deberia llamar a Adobe.ofertaCuenta()", () => {
      Adobe.ofertaCuenta(context);
      expect(Adobe.ofertaCuenta).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.ofertaEmprendedores()", () => {
      Adobe.ofertaEmprendedores(context);
      expect(Adobe.ofertaEmprendedores).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.datosPersonales()", () => {
      Adobe.datosPersonales(context);
      expect(Adobe.datosPersonales).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.datosLaborales()", () => {
      Adobe.datosLaborales(context);
      expect(Adobe.datosLaborales).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.informacionAdicional()", () => {
      Adobe.informacionAdicional(context);
      expect(Adobe.informacionAdicional).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.identidad()", () => {
      Adobe.identidad(context);
      expect(Adobe.identidad).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.loadingVeridas()", () => {
      Adobe.loadingVeridas(context);
      expect(Adobe.loadingVeridas).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.biometriaOK()", () => {
      Adobe.biometriaOK(context);
      expect(Adobe.biometriaOK).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.configuracion()", () => {
      Adobe.configuracion(context);
      expect(Adobe.configuracion).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.contrato()", () => {
      Adobe.contrato(context);
      expect(Adobe.contrato).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.graciasCajaAhorro()", () => {
      Adobe.graciasCajaAhorro(context);
      expect(Adobe.graciasCajaAhorro).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.graciasEmprendedores()", () => {
      Adobe.graciasEmprendedores(context);
      expect(Adobe.graciasEmprendedores).toHaveBeenCalledTimes(1);
    });
  });

  describe("Eventos del camino 2", () => {
    const context = {};
    beforeEach(() => {
      window.digitalData = {};
      jest.spyOn(Adobe, "oferta");
      jest.spyOn(Adobe, "paso1");
      jest.spyOn(Adobe, "paso2");
      jest.spyOn(Adobe, "paso3");
      jest.spyOn(Adobe, "paso4");
      jest.spyOn(Adobe, "gracias");
    });

    afterEach(() => {
      jest.clearAllMocks();
    });

    it("deberia llamar a Adobe.oferta()", () => {
      Adobe.oferta(context);
      expect(Adobe.oferta).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.paso1()", () => {
      Adobe.paso1(context);
      expect(Adobe.paso1).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.paso2()", () => {
      Adobe.paso2(context);
      expect(Adobe.paso2).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.paso3()", () => {
      Adobe.paso3(context);
      expect(Adobe.paso3).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.paso4()", () => {
      Adobe.paso4(context);
      expect(Adobe.paso4).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.gracias()", () => {
      Adobe.gracias(context);
      expect(Adobe.gracias).toHaveBeenCalledTimes(1);
    });
  });

  describe("Eventos del Camino 3", () => {
    const context = {};
    beforeEach(() => {
      window.digitalData = {};
      jest.spyOn(Adobe, "cliente");
    });

    afterEach(() => {
      jest.clearAllMocks();
    });

    it("deberia llamar a Adobe.cliente()", () => {
      Adobe.cliente(context);
      expect(Adobe.cliente).toHaveBeenCalledTimes(1);
    });
  });

  describe("Eventos del Camino 4", () => {
    const context = {};
    beforeEach(() => {
      window.digitalData = {};
      jest.spyOn(Adobe, "confirmar");
      jest.spyOn(Adobe, "noCliente");
    });

    afterEach(() => {
      jest.clearAllMocks();
    });

    it("deberia llamar a Adobe.confirmar()", () => {
      Adobe.confirmar(context);
      expect(Adobe.confirmar).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.noCliente()", () => {
      Adobe.noCliente(context);
      expect(Adobe.noCliente).toHaveBeenCalledTimes(1);
    });
  });

  describe("Eventos del Camino 5", () => {
    const context = {};
    beforeEach(() => {
      window.digitalData = {};
      jest.spyOn(Adobe, "clienteCA");
      jest.spyOn(Adobe, "ingresoBancaOnline");
    });

    afterEach(() => {
      jest.clearAllMocks();
    });

    it("deberia llamar a Adobe.clienteCA()", () => {
      Adobe.clienteCA(context);
      expect(Adobe.clienteCA).toHaveBeenCalledTimes(1);
    });
  });

  describe("Eventos Comunes", () => {
    const context = { state: { confirmarRenaper: { expediente: "error" } } };
    beforeEach(() => {
      window.digitalData = {};
      jest.spyOn(Adobe, "celular");
      jest.spyOn(Adobe, "mensaje");
      jest.spyOn(Adobe, "sucursal");
      jest.spyOn(Adobe, "thankOTP");
      jest.spyOn(Adobe, "consulta");
      jest.spyOn(Adobe, "usuarioClave");
      jest.spyOn(Adobe, "renaperConfirmar");
      jest.spyOn(Adobe, "renaperConsultar");
      jest.spyOn(Adobe, "continuaSucursal");
      jest.spyOn(Adobe, "mensajeEmprendedoresCGUCA");
    });

    afterEach(() => {
      jest.clearAllMocks();
    });

    it("deberia llamar a Adobe.consulta()", () => {
      Adobe.consulta(context);
      expect(Adobe.consulta).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.sucursal()", () => {
      Adobe.sucursal(context);
      expect(Adobe.sucursal).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.mensajeEmprendedoresCGUCA() x ERROR_SOLICITUD", () => {
      const context = {
        mutation: {
          payload: { params: { mje: STEP_CONSTANTS.ERROR_SOLICITUD } }
        }
      };
      Adobe.mensajeEmprendedoresCGUCA(context);
      expect(Adobe.mensajeEmprendedoresCGUCA).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.mensajeEmprendedoresCGUCA() x default", () => {
      const context = {
        mutation: {
          payload: { params: { mje: "otro_msj" } }
        }
      };
      Adobe.mensajeEmprendedoresCGUCA(context);
      expect(Adobe.mensajeEmprendedoresCGUCA).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.renaperConfirmar()", () => {
      Adobe.renaperConfirmar(context);
      expect(Adobe.renaperConfirmar).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.celular()", () => {
      Adobe.celular(context);
      expect(Adobe.celular).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.usuarioClave()", () => {
      Adobe.usuarioClave(context);
      expect(Adobe.usuarioClave).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.thankOTP()", () => {
      Adobe.thankOTP(context);
      expect(Adobe.thankOTP).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.renaperConsultar()", () => {
      Adobe.renaperConsultar(context);
      expect(Adobe.renaperConsultar).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.continuaSucursal()", () => {
      Adobe.continuaSucursal(context);
      expect(Adobe.continuaSucursal).toHaveBeenCalledTimes(1);
    });
    it("deberia llamar a Adobe.mensaje() por RECHAZADO", () => {
      const context = {
        mutation: {
          payload: { params: { mje: STEP_CONSTANTS.RECHAZADO } }
        }
      };
      Adobe.mensaje(context);
      jest.runAllTimers();
      expect(Adobe.mensaje).toHaveBeenCalled();
    });
    it("deberia llamar a Adobe.mensaje() por RECHAZADO_OTROS", () => {
      const context = {
        mutation: {
          payload: { params: { mje: STEP_CONSTANTS.RECHAZADO_OTROS } }
        }
      };
      Adobe.mensaje(context);
      jest.runAllTimers();
      expect(Adobe.mensaje).toHaveBeenCalled();
    });
    it("deberia llamar a Adobe.mensaje() por INDIVIDUO_NEGATIVO", () => {
      const context = {
        mutation: {
          payload: { params: { mje: STEP_CONSTANTS.INDIVIDUO_NEGATIVO } }
        }
      };
      Adobe.mensaje(context);
      jest.runAllTimers();
      expect(Adobe.mensaje).toHaveBeenCalled();
    });
    it("deberia llamar a Adobe.mensaje() por ERROR_CONFIRMACION_RENAPER", () => {
      const context = {
        mutation: {
          payload: {
            params: { mje: STEP_CONSTANTS.ERROR_CONFIRMACION_RENAPER }
          }
        }
      };
      Adobe.mensaje(context);
      jest.runAllTimers();
      expect(Adobe.mensaje).toHaveBeenCalled();
    });
    it("deberia llamar a Adobe.mensaje() por default", () => {
      const context = {
        mutation: {
          payload: {
            params: { mje: "otro_msj" }
          }
        }
      };
      Adobe.mensaje(context);
      jest.runAllTimers();
      expect(Adobe.mensaje).toHaveBeenCalled();
    });
    it("deberia llamar a Adobe.mensaje() por default y error expediente", () => {
      const context = {
        state: { confirmarRenaper: { expediente: "error" } },
        mutation: {
          payload: {
            params: { mje: "otro_msj" }
          }
        }
      };
      Adobe.mensaje(context);
      jest.runAllTimers();
      expect(Adobe.mensaje).toHaveBeenCalled();
    });
  });
});
